import { render, staticRenderFns } from "./DocumentLibrary.vue?vue&type=template&id=0997f168&scoped=true"
import script from "./DocumentLibrary.vue?vue&type=script&lang=js"
export * from "./DocumentLibrary.vue?vue&type=script&lang=js"
import style0 from "./DocumentLibrary.vue?vue&type=style&index=0&id=0997f168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997f168",
  null
  
)

export default component.exports